import * as React from 'react';
import * as queryString from 'query-string';
import * as confirmStore from '@/redux/ui/confirm';
import Item from './item';
import config from '@/server/config';
import request from '@/server/request';
import store from '@/redux';

export default class YLKList extends React.Component<any, any> {
    private loadTimer: any;

    constructor(props: any) {
        super(props);

        this.state = {
            keyword: '', // 搜索关键词
            list: [], // 列表
            filterVisible: false, // 筛选可视化
            filterValue: -1, // -1(默认)全部，0，待审核，1审核通过，2审核不通过
            type: Number(queryString.parse(this.props.history.location.search).type || 1), // 页面类型 1.认领产品 2.录入产品 3.编辑记录 4.收藏产品 5.配方中心
            page: 1, // 页码
            isLoading: true, // 是否加载中
            loadOver: false, // 是否全部加载完
        }
    }

    public componentDidMount() {
        this.getData();

        window.addEventListener('scroll', this.scrollAction.bind(this));
    }

    public componentWillUnmount() {
        window.removeEventListener('scroll', this.scrollAction.bind(this));

        if (this.loadTimer) {
            clearTimeout(this.loadTimer);
        }

        // 卸载异步操作设置状态
        this.setState = (state, callback) => {
            return;
        }
    }

    public render() {
        const state = this.state;
        return (
            <section>
                <div className="ylk-search">
                    <div className="ylk-search-group">
                        <img src={require('../../../assets/images/icon-search.png')} alt="" />
                        <input type="text" placeholder="名称、牌号、生产商" defaultValue={state.keyword} onChange={() => this.searchAction()}
                            onKeyDown={() => this.searchKeyDownAction()} />
                    </div>
                    <button onClick={() => this.searchStartAction()}>搜索</button>
                </div>
                {
                    (state.type === 2 || state.type === 3) ?
                        <div className="ylk-list-filter">
                            <dl>
                                <dt onClick={() => this.setFilterVisible(true)}>
                                    <p>{['全部', '待审核', '审核通过', '审核不通过'][state.filterValue + 1]}</p> <i></i>
                                </dt>
                                <dd className={`${state.filterVisible ? 'active' : ''}`}>
                                    <p onClick={() => this.setFilter(-1)}>全部</p>
                                    <p onClick={() => this.setFilter(0)}>待审核</p>
                                    <p onClick={() => this.setFilter(1)}>审核通过</p>
                                    <p onClick={() => this.setFilter(2)}>审核不通过</p>
                                </dd>
                            </dl>
                        </div> : null
                }
                <p className={`ylk-mask ${state.filterVisible ? 'active' : ''}`} onClick={() => this.setFilterVisible(false)}></p>
                <div className="ylk-list">
                    {
                        state.list.map((v: any, k: number) => {
                            const id = [v.details_id, v.details_log_id, v.details_log_id, v.details_id, v.formula_id][state.type - 1];
                            return (
                                <Item key={id} type={state.type} data={v}
                                    showReason={() => this.showReason(v.failure_reason)}
                                    remove={() => this.remove(id, k)}
                                    delete={() => this.delete(id, k)}
                                    history={this.props.history} />
                            )
                        })
                    }
                </div>
                <p className="loading-tips">{this.state.loadOver ? '没有更多数据' : '数据加载中...'}</p>
            </section>
        )
    }
    /**
     * 筛选显示隐藏
     * @param visible {boolean} 显示、隐藏
     */
    private setFilterVisible(visible: boolean) {
        this.setState({
            filterVisible: visible
        });
    }

    // 获取数据
    private async getData() {
        const r = await request({
            url: config.ULKAPI + [
                'api/web/index.php?r=member/product/goods-list',
                'api/web/index.php?r=member/product/goods-list',
                'api/web/index.php?r=member/product/goods-list',
                'api/web/index.php?r=member/product/collect-list',
                'api/web/index.php?r=member/formula/list'
            ][this.state.type - 1],
            method: 'post',
            data: {
                type: this.state.type,
                pageSize: 10,
                page: this.state.page,
                state: this.state.filterValue,
                name: this.state.type < 5 ? this.state.keyword : '',
                formulaName: this.state.type === 5 ? this.state.keyword : ''
            }
        });

        if (r.error_code === 0) {
            const loadOver = Number(r.data.page) >= r.data.page_count;

            this.setState({
                list: [...this.state.list, ...r.data.model],
                isLoading: false,
                loadOver
            });
        }
    }

    /**
     * 加载更多
     * 滚动加载更多数据
     */
    private scrollAction() {
        if (this.state.isLoading || this.state.loadOver) {
            return;
        }

        if (window.pageYOffset + window.innerHeight + 50 > document.body.scrollHeight) {

            if (this.loadTimer) {
                clearTimeout(this.loadTimer);
            }

            this.loadTimer = setTimeout(() => {
                this.loadMore();
            }, 500);

        }
    }

    // 加载更多文章内容
    private loadMore() {
        this.setState({
            isLoading: true,
            page: this.state.page + 1
        }, () => {
            this.getData();
        });
    }

    // 搜索
    private searchAction() {
        this.setState({
            keyword: (event as any).target.value
        });
    }

    // 搜索框输入
    private searchKeyDownAction() {
        if ((event as any).keyCode === 13) {
            this.searchStartAction();
        }
    }

    /**
     * 筛选
     * @param value {number} 值 
     */
    private setFilter(value: number) {
        this.setState({
            filterValue: value,
            filterVisible: false
        }, () => {
            this.searchStartAction();
        });
    }

    // 搜索
    private searchStartAction() {
        this.setState({
            list: [],
            page: 1,
            isLoading: false,
            loadOver: false
        }, () => {
            this.getData();
        });
    }

    /**
     * 显示拒绝理由
     * @param reason {string|any} 拒绝理由
     */
    private showReason(reason: string | any) {
        store.dispatch({
            type: confirmStore.types.CONFIRM_SHOW,
            data: {
                text: reason,
                type: 1
            }
        });
    }

    /**
     * 移除
     * @param id {number}
     * @param index {number} 索引
     */
    private remove(id: number, index: number) {
        store.dispatch({
            type: confirmStore.types.CONFIRM_SHOW,
            data: {
                text: '是否确定移除？',
                onConfirm: async () => {
                    const r = await request({
                        url: `${config.ULKAPI}api/web/index.php?r=product/del-claim&id=${id}`,
                        method: 'post',
                        data: {
                            id
                        }
                    });

                    if (r.error_code === 0) {
                        const temp = this.state.list;

                        temp.splice(index, 1);

                        this.setState({
                            list: temp
                        }, () => {
                            if (!this.state.loadOver && this.state.list.length < 10) {
                                this.loadMore();
                            }
                        });
                    }
                }
            }
        });
    }

    /**
     * 删除
     * @param id {number}
     * @param index {number} 索引
     */
    private delete(id: number, index: number) {
        store.dispatch({
            type: confirmStore.types.CONFIRM_SHOW,
            data: {
                text: '是否确定删除？',
                onConfirm: async () => {
                    let url = '';
                    let data = {};

                    if (this.state.type === 4) {
                        url = `${config.ULKAPI}api/web/index.php?r=member/product/save-collect`;
                        data = {
                            id,
                            type: 2
                        };
                    } else if (this.state.type === 5) {
                        url = `${config.ULKAPI}api/web/index.php?r=member/formula/del-formula`;
                        data = {
                            id
                        };
                    } else {
                        url = `${config.ULKAPI}api/web/index.php?r=member/product/save-product-log&logId=${id}`;
                        data = {
                            logId: id
                        };
                    }

                    const r = await request({
                        url,
                        method: 'post',
                        data
                    });

                    if (r.error_code === 0) {
                        const temp = this.state.list;
                        temp.splice(index, 1);
                        this.setState({
                            list: temp
                        }, () => {
                            if (!this.state.loadOver && this.state.list.length < 10) {
                                this.loadMore();
                            }
                        });
                    }
                }
            }
        });
    }
}